module.exports = __webpack_public_path__ + "img/gopinath.73ddd74c.png";